import React, { Component } from 'react';
import { getCurrentEnvironmentConfig } from "../../util/AppUtil";

class ToolbarTemplateCostcoMarketing extends Component {
    render() {
        return (
            <React.Fragment>
                <h1 className={`zuul-toolbar zuul-toolbar-costco costco-header marketing-logo-wrapper `} aria-label='Header'><span style={{ display: 'none' }}>Header</span>
                    <div aria-label='shutterfly logo' className={'logo logo4 marketing-logo'} onClick={() => {window.location.href = getCurrentEnvironmentConfig().wwwBaseUrl}}></div>
                </h1>
                {this.props.children}
            </React.Fragment>
        );
    }
}


export default ToolbarTemplateCostcoMarketing;
